import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import logoImg from "../assets/skyovi-logo.png";
import idpLogo from "../assets/IntelliDropLogo-new.png";

export default function Navbar() {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [anchorEl, setAnchorEl] = useState(null);
  const isClientUser = !!localStorage.getItem('clientToken');

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    if (localStorage.getItem('clientToken')) {
      localStorage.removeItem('clientToken');
      localStorage.removeItem('clientName');
      localStorage.removeItem('clientEmail');
      localStorage.removeItem('allowedProjects');
      navigate('/client-login');
    } else {
      instance.logoutRedirect({ postLogoutRedirectUri: "/" });
    }
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        top: 0,
        zIndex: 1200,
        background: "#FFFFFF",
        height: 68,
        boxShadow: "0 2px 8px rgba(15, 23, 42, 0.08)",
        borderBottom: "1px solid #DDE7F0",
      }}
    >
      <Toolbar sx={{ color: "#172033", minHeight: "68px !important", gap: 2, px: { xs: 2, md: 4 } }}>
        <Box
          component="img"
          src={logoImg}
          alt="Brightspeed Logo"
          sx={{
            height: 44,
            width: "auto",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} />
        <Box
          component="img"
          src={idpLogo}
          alt="IntelliDrop Logo"
          sx={{ height: 36, width: "auto", marginRight: 0, marginTop: "4px" }}
        />
        <IconButton
          size="large"
          edge="end"
          sx={{ ml: 0, color: "#172033" }}
          onClick={handleMenu}
        >
          <AccountCircle sx={{ fontSize: 32 }} />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          {!isClientUser && (
            <MenuItem onClick={() => { handleClose(); navigate('/client-logs'); }}>Client Login Logs</MenuItem>
          )}
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
